module.exports = __webpack_public_path__ + "img/nata.27b88acd.gif";